"use client"

import { useTheme } from "next-themes"
import { Toaster as Sonner, type ToasterProps } from "sonner"
import {
  CircleCheckIcon,
  InfoIcon,
  Loader2Icon,
  OctagonXIcon,
  TriangleAlertIcon,
} from "lucide-react"

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      icons={{
        success: <CircleCheckIcon className="tw-size-4" />,
        info: <InfoIcon className="tw-size-4" />,
        warning: <TriangleAlertIcon className="tw-size-4" />,
        error: <OctagonXIcon className="tw-size-4" />,
        loading: <Loader2Icon className="tw-size-4 tw-animate-spin" />,
      }}
      toastOptions={{
        classNames: {
          toast:
            "tw-border tw-rounded-lg tw-shadow-lg tw-font-sans tw-py-4 tw-px-6 tw-min-w-[400px]",
          title: "!tw-text-sm",
          description: "!tw-text-sm",
          success: "tw-border-emerald-600 !tw-bg-emerald-600 !tw-text-white",
          error: "tw-border-red-600 tw-bg-red-50 tw-text-gray-900",
          warning: "tw-border-yellow-600 tw-bg-yellow-50 tw-text-gray-900",
          info: "tw-border-blue-600 tw-bg-blue-50 tw-text-gray-900",
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
